import React, { useEffect } from "react";
import { Header } from "../components/Header";
import { Contact, Footer } from "../components/ContactFooter";
import { WhatsAppButton } from "../components/WhatsAppButton";

export default function ContactosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0A0A0A]" data-testid="contactos-page">
      <Header />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
